import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { HECoSSubjectValidatorService } from '@uc/web/core';
import { DEGREE_ROUTES } from '../static/courses-filter.properties';

export const validateSubjectGuard = async (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot,
) => {
	const router = inject(Router);
	const hecosSubjectValidatorSrv = inject(HECoSSubjectValidatorService);
	const subject = route.params['subject'];

	const isHECoSSubject = await hecosSubjectValidatorSrv.isHECoSSubject(subject);

	if (!isHECoSSubject) {
		const url = state.url.split('/').filter(Boolean);
		const defaultDegree = 'degrees';
		const degree =
			url.find((segment) => DEGREE_ROUTES.includes(segment)) || defaultDegree;

		const segments = new Set(['/courses', 'search', degree].filter(Boolean));
		const queryParams = { search: subject };

		router.navigate([...segments], { queryParams });

		return false;
	}

	return true;
};
